<script setup>
import * as Notice from '@/services/Notice'
</script>

<template>
  <!-- `persistent`: it goes away only through its own button, not with Esc and not by clicking
       outside. The state is shared and this is the only instance of the dialog (mounted in
       App.vue), so a second play button on the page cannot open a second one. -->
  <v-dialog :model-value="Notice.isOpen()" persistent max-width="520">
    <v-card class="pt-4">
      <v-card-title class="text-h6 d-flex align-center ga-2">
        <v-icon color="primary">mdi-emoticon-happy-outline</v-icon>
        {{ $t('notice.title') }}
      </v-card-title>

      <v-card-text class="text-body-1 notice-body">
        {{ $t('notice.body') }}
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" variant="elevated" @click="Notice.acknowledge()">
          {{ $t('notice.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
/* The breaks written in the lang files (\n) show up as breaks: the notice is a few short paragraphs,
   not a block of text. */
.notice-body {
  white-space: pre-line;
}
</style>
